// Test IDs for case study pages
export const CASE_STUDY = {
    page: 'case-study-page',
    backHome: 'case-study-back-home',
    title: 'case-study-title',
    metaRole: 'case-study-meta-role',
    metaYear: 'case-study-meta-year',
    metaClient: 'case-study-meta-client',
    metaDuration: 'case-study-meta-duration',
    cover: 'case-study-cover',
    prototypeLink: 'case-study-prototype-link',
    galleryImg: (i) => `case-study-gallery-img-${i}`,
    nextCta: 'case-study-next-cta',
    notFound: 'case-study-not-found',
    tabTrigger: (i) => `case-study-tab-trigger-${i}`,
    tabPanel: (i) => `case-study-tab-panel-${i}`,
    accordionTrigger: (i) => `case-study-accordion-trigger-${i}`,
    accordionPanel: (i) => `case-study-accordion-panel-${i}`,
};
